/**
 * sg-attachment directive
 *
 * Directive that shows previews of uploads, and lets you download them
 *
 * @param {string} Attachments - object path to the attachments on the scope.
 * (e.g. if scope = { element: { uploads: [files] } } then attachments="element.uploads")
 * @param {boolean} Carousel - add carousel attribute to go into carousel mode
 *
 */
(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgAttachments', sgAttachments);

  function sgAttachments () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-attachments/sg-attachments.html',
      controller: 'sgAttachmentsController',
      controllerAs: 'vm',
      scope: true,
      bindToController: {
        attachments: '<',
        carousel: '<?'
      }
    };
  }
})();
